import { useState } from 'react';
import { Filter } from '../../../../types/catalog';

interface FilterAccordionProps extends Filter {
    toggleValue: (idx: number) => void;
    selected: string[];
    openDefault: boolean;
}

function FilterAccordion({ name, values, selected, toggleValue, openDefault }: FilterAccordionProps) {
    const [isOpen, setIsOpen] = useState(openDefault);
    return (
        <div className={'catalog-filter item' + (isOpen ? ' active' : '')}>
            <span className="catalog-filter__title head" onClick={() => setIsOpen(!isOpen)}>
                {name}
            </span>
            <div className={'catalog-filter__content content' + (!isOpen ? ' hidden collapsed' : '')}>
                <div className="catalog-filter__options">
                    {values.map((v, idx) => (
                        <label
                            key={v.value}
                            className="checkbox iek-prodcat-catalog-section-filter-values__value-wrap"
                        >
                            <input
                                checked={selected.includes(v.value)}
                                onChange={() => toggleValue(idx)}
                                type="checkbox"
                            />
                            <span className="ui-checkbox__icon" />
                            <span className="checkbox__txt">
                                {v.value} <span className="txt-gray">({v.productCount})</span>
                            </span>
                        </label>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default FilterAccordion;
